import axios from "axios";
import { store } from "../../config/store";
import { getCompanyToken, getCurrentCompanyInfo } from "../../utils/companySession";

//const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIyOTc2IiwibmFtZSI6InNvbWVvbmUiLCJyb2xlSWQiOiI1Iiwicm9sZSI6IlVzZXIiLCJqdGkiOiI0YzJlNDBiNi03ZjIzLTQ2ZWUtOWY0OS00YTdmMWMyOTEwOTkiLCJleHAiOjE3OTQ5ODE3ODIsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6NTAwMS8iLCJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjUwMDEvIn0.BFEfwECSTObxDzGPffXz5NmCkhxx1we6UuRMphJwiEY';

const get909Event = async () => {
  const { userInfo } = store.getState();
  const companyInfo = getCurrentCompanyInfo(userInfo);
  const validCompanyToken = getCompanyToken(companyInfo);

  const headersList = {
    Accept: "*/*",
    "Authorization": 'Bearer ' + validCompanyToken,
    "Content-Type": "application/json",
  };
  const payload = {
    userId: 2976,
    isMix: true
};
  const reqOptions = {
    url: "https://api.sport909.com/api/Home/events-from-companies",
    method: "GET",
    headers: headersList,
   // data : payload
  };
  const response = await axios.request(reqOptions);
  return response;
};

const get555Event = async () => {
    const headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin" : "*",
      "Access-Control-Allow-Methods":"GET,PUT,POST,DELETE,PATCH,OPTIONS",
    };
    const reqOptions = {
      url: "https://api.555mix.com/api/collections/last/all",
      method: "GET",
      headers: headersList
    };
    const response = await axios.request(reqOptions);
    return response;
  };



export { get909Event, get555Event};
